import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {first} from 'rxjs/operators';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {Attribute, Customer} from '~core/models';
import {AttributeService} from '~core/services';
import {TooltipTranslationService} from '~shared/translations';

/**
 * Displays attributes inside of an info tile
 */
@UntilDestroy()
@Component({
  selector: '[app-attributes-info]',
  templateUrl: './attributes-info.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class AttributesInfoComponent implements OnInit, OnDestroy {
  public attributes: Array<Attribute> = [];
  public clubAttributes: Array<Attribute> = [];
  public spinnerName: string = 'attributesLoading';
  public spinnerLoading: boolean = true;

  @Input() public customer: Customer;

  constructor(
    private attributeService: AttributeService,
    public customerService: CustomerOverViewService,
    public spinnerService: SpinnerService,
    public tooltipTranslations: TooltipTranslationService,
  ) {
    this.attributeService.castCustomerAttributes.pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data !== null) {
          const arr = [];
          for (const el of data) {
            arr.push(el.attribute);
          }
          this.attributes = arr;
          this.sortAttributes();
        }
      });
  }

  public ngOnInit(): void {
    this.getAttributes();
  }

  public ngOnDestroy(): void {
    this.attributeService.announceCustomerAttributes(null);
  }

  /**
   * Filter club-overview attributes and open the edit attribute modal.
   */
  public editAttributes(): any {
    this.customerService.toggleAllModal(false);
    this.customerService.toggleEditAttributeDataModal(true);
  }

  /**
   * Sort the list of attributes
   */
  public sortAttributes(): void {
    this.attributes.sort((a, b): any => a.name.localeCompare(b.name));
    this.attributes.sort((a, b): any => a.status === b.status ? 0 : a.status.localeCompare(b.status));
  }

  /**
   * Function that fetches all the attributes
   */
  public getAttributes(): void {
    this.attributeService.getCustomerAttribute(this.customer.id)
      .pipe(first())
      .subscribe((data: any) => {
        this.attributeService.announceCustomerAttributes(data);
        this.spinnerService.hide(this.spinnerName);
      });
  }

}
